var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPrimaryConsumer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#619BF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.741 19C21.1063 19 23.8347 20.3431 23.8347 22C23.8347 23.6569 21.1063 25 17.741 25C14.3758 24.9999 11.6482 23.6568 11.6482 22C11.6482 20.3432 14.3758 19.0001 17.741 19ZM12.0359 19.0195C10.8468 19.8133 10.1248 20.8566 10.1248 22C10.1248 22.6482 10.3566 23.2645 10.7742 23.8213C8.90537 23.4523 7.58569 22.552 7.58569 21.5C7.58581 20.224 9.52783 19.1718 12.0359 19.0195ZM23.447 19.0195C25.9551 19.1718 27.8971 20.224 27.8972 21.5C27.8972 22.5519 26.5774 23.4522 24.7087 23.8213C25.1263 23.2645 25.3582 22.6481 25.3582 22C25.3581 20.8567 24.636 19.8133 23.447 19.0195ZM12.6638 13C12.8731 13 13.0754 13.031 13.2654 13.0889C13.204 13.383 13.1716 13.6879 13.1716 14C13.1716 14.9404 13.4646 15.8132 13.9656 16.5352C13.6132 16.8251 13.159 16.9999 12.6638 17C11.542 17 10.6326 16.1046 10.6326 15C10.6326 13.8954 11.542 13 12.6638 13ZM17.741 11C19.4236 11 20.7878 12.3431 20.7878 14C20.7878 15.6569 19.4236 17 17.741 17C16.0585 16.9998 14.6951 15.6567 14.6951 14C14.6951 12.3433 16.0585 11.0002 17.741 11ZM22.8191 13C23.9409 13 24.8503 13.8954 24.8503 15C24.8503 16.1046 23.9409 17 22.8191 17C22.3238 17 21.8698 16.8252 21.5173 16.5352C22.0182 15.8132 22.3113 14.9404 22.3113 14C22.3113 13.6879 22.2789 13.383 22.2175 13.0889C22.4076 13.0309 22.6097 13 22.8191 13Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPrimaryConsumer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-primary-consumer.286a385ecbe8fab37f81e8a32404deaf.svg";